import { defaultLogisticsPartner, LogisticsPartner } from "./logisticsPartner";

export type PickupAgent = {
  id: string;
  name?: string;
  agent?: LogisticsPartner;
};

export const defaultPickupAgent: PickupAgent = {
  id: "",
  agent: defaultLogisticsPartner,
};
